import {
    CalculatorIcon,
    BookOpenIcon,
    BeakerIcon,
} from "@heroicons/react/20/solid";
import fallBackImage from '../Assests/images/placeholderimage.jpg'
import { Link } from "react-router-dom";
import helpers from "../utils/helpers";

// Utility: pick icon based on app name
const getAppIcon = (name) => {
    if (name.includes("Math"))
        return <CalculatorIcon className="w-5 h-5 text-blue-500" />;
    if (name.includes("Science"))
        return <BeakerIcon className="w-5 h-5 text-green-500" />;
    if (name.includes("History"))
        return <BookOpenIcon className="w-5 h-5 text-yellow-600" />;
    return <BookOpenIcon className="w-5 h-5 text-gray-400" />; // fallback
};

// ✅ Checkbox Cell
export const CheckboxCell = ({ checked, onChange }) => (

    <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="h-5 w-5"
    />

);

// ✅ App Cell (with icon + subject)
export const AppCell = ({ app, subject, img, id, permission }) => (

    <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg">
            {/* {getAppIcon(app)} */}
            <img src={img || fallBackImage} alt={app} className="w-10 h-10 rounded-lg object-cover" onError={(e) => {
                e.target.onerror = null;
                e.target.src = fallBackImage;
            }} />
        </div>
        <div>
            {permission?.view === true ?
                <Link to={`/applications/${helpers.encryptId(id)}`}>
                    <div className="font-bold text-[16px] text-[#283C50] hover:underline cursor-pointer">
                        {app}
                    </div>
                </Link>
                :
                <div className="font-bold text-[16px] text-[#283C50]">
                    {app}
                </div>
            }
            <div className="text-[14px] text-[#717576] ">{subject}</div>
        </div>
    </div>

);

// ✅ Educator Cell (with avatar)
export const EducatorCell = ({ educators }) => (
    <div className="flex items-center gap-2">
        {educators?.length > 0 ?
            <>
                <img
                    src={educators[0]?.profile_pic || fallBackImage}
                    alt="avatar"
                    className="w-8 h-8 rounded-full"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = fallBackImage;
                    }}
                />
                <p className="text-[15px]">{educators[0]?.educator_name}</p>
                {educators?.length > 1 && (
                    <span className="text-[12px] p-1 rounded-full text-white bg-primary-500">
                        {" "}+{educators?.length - 1} more
                    </span>
                )}
            </>
            : <span>No Educator</span>
        }
    </div>
);

// ✅ Adoption Cell (clickable users count)
export const AdoptionCell = ({ count }) => (
    <div>
        <p className="text-brandBlue hover:underline cursor-pointer text-[15px]">
            {count} Users
        </p>
    </div>
);

// ✅ Status Cell (colored text)
export const StatusCell = ({ status }) => (
    <div>
        {status === 1 ? (
            <span className="text-green-600 font-medium text-[15px]">✓ Active</span>
        ) : (
            <span className="text-gray-500 text-[15px]">Inactive</span>
        )}
    </div>
);
